import { find, get, isString, noop } from 'lodash'
import React from 'react'
import styled from 'styled-components'

import { ISortsProps, IUi, TDirection, TFApplyFilter, TSort } from '../types'

export interface SortProps extends ISortsProps {
  applyFilter?: TFApplyFilter
  useLocalStateFiltering?: boolean
  setCurrentRow?: (val: number) => void
  ui?: IUi
  label?: React.ReactNode
  direction?: TDirection
}

const Wrapper = styled.div`
  cursor: pointer;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
`

const Sort = (props: SortProps): React.ReactElement => {
  const {
    sorts = [],
    applyFilter,
    setSort,
    sortableColumns = [],
    applyLocalSort,
    useLocalStateFiltering,
    setCurrentRow,
    ui,
    sortKey = '',
    label,
    disableSort,
    direction,
  } = props

  const sort = find(sorts as TSort[], (sort) =>
    sort.field ? sort.field[0] === sortKey : false,
  )

  const handleSortClick = (field: string): void => {
    setSort && setSort({ field })
    if (useLocalStateFiltering) {
      if (applyLocalSort) {
        applyLocalSort({ reset: false })
      }
    } else {
      if (applyFilter) {
        applyFilter({ reset: { reset: false } })
      }
      if (setCurrentRow) {
        setCurrentRow(get(ui, 'currentRow', 0))
      }
    }
  }
  if (sort && !disableSort) {
    return (
      <Wrapper
        onClick={
          sort.field && isString(sort.field?.[0])
            ? () => handleSortClick(sort.field?.[0] as string)
            : noop
        }
      >
        {isString(label)
          ? `${label}`
          : React.cloneElement(label as React.ReactElement)}{' '}
        <i
          className={`fas fa-sort-amount-${
            sort.direction === 'asc' ? 'down' : 'up'
          } `}
        />{' '}
      </Wrapper>
    )
  } else if (!sort && sortableColumns.includes(sortKey)) {
    return (
      <Wrapper onClick={() => handleSortClick(sortKey)}>
        {isString(label)
          ? `${label}`
          : React.cloneElement(label as React.ReactElement)}{' '}
        <i className="fas fa-sort-alt text-muted" />{' '}
      </Wrapper>
    )
  }

  return <Wrapper>{props.label}</Wrapper>
}

export default Sort
